import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {Appointments, GetAppoinmentModel} from '../models';
import {AppointmentType} from '../utility/appointment-type.enum';

@Injectable()
export class AppointmentsAdapter implements IAdapter<Appointments> {
  adaptToModel(resp: any): Appointments {
    const appnt: Appointments = {...resp};

    if (!appnt.checkInDate && !appnt.checkOutDate) {
      appnt.checkinBtnClass = 'green footer-button';
      appnt.checkinBtnStatus = 'gray';
    }

    if (appnt.checkInDate && !appnt.checkOutDate) {
      appnt.badgeText = 'In';
      appnt.badgeStatus = 'success';
      appnt.checkinBtnClass = 'footer-button';
      appnt.checkinBtnStatus = 'primary';
    }

    if (appnt.checkInDate && appnt.checkOutDate) {
      appnt.badgeText = 'Done';
      appnt.badgeStatus = 'primary';
      appnt.checkinBtnClass = 'footer-button';
      appnt.checkinBtnStatus = 'primary';
    }

    if (appnt.apptType === AppointmentType.DoctorVisit) {
      appnt.appntImage = './assets/doc-visit.svg';
    } else if (appnt.apptType === AppointmentType.LabVisit) {
      appnt.appntImage = './assets/lab-visit.svg';
    } else if (appnt.apptType === AppointmentType.Chemotherapy) {
      appnt.appntImage = './assets/cheomotherapy.svg';
    } else if (appnt.apptType === AppointmentType.Radiotherapy) {
      appnt.appntImage = './assets/radiotherapy.svg';
    } else if (appnt.apptType === AppointmentType.Surgery) {
      appnt.appntImage = './assets/surgery.svg';
    } else {
      // Do nothing
    }

    return appnt;
  }
  adaptFromModel(data: Appointments): any {
    const dataToSend = Object.assign({}, data);

    delete dataToSend.badgeText;
    delete dataToSend.badgeStatus;
    delete dataToSend.checkinBtnClass;
    delete dataToSend.checkinBtnStatus;

    return dataToSend;
  }
}

@Injectable()
export class GetAppointmentsAdapter implements IAdapter<GetAppoinmentModel> {
  adaptToModel(resp: any): GetAppoinmentModel {
    const appnt: GetAppoinmentModel = {...resp};

    return appnt;
  }
  adaptFromModel(data: GetAppoinmentModel): any {
    return Object.assign({}, data);
  }
}
